import React, { useContext } from "react";
import { PrimaryButton } from "@fluentui/react";
import { t } from "i18next";
// import ModalHeader from "../Modal/ModalHeader";
// import ModalMain from "../Modal/ModalMain";
// import themeContext from "../../context/theme/ThemeContext";
import ModalMain from "./Modal/ModalMain";
import ModalHeader from "./Modal/ModalHeader";
import ModalFooter from "./Modal/ModalFooter";
import themeContext from "../context/theme/ThemeContext";
import {Warning24Regular
} from '@fluentui/react-icons';

const AccountWarningModal = ({ showModal, hideModal, warningText }) => {
  const { getThemeColor } = useContext(themeContext);

  const handleAcknowledge = () => {
    hideModal();
  };

   let DefaultButtonList = [
        {
          title: t("button.ok"),
          onclick: handleAcknowledge,
        },
      ];

  const modalDetails = {
    header: (
        <ModalHeader
        updatedModal={true}
        heading={
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <Warning24Regular 
              style={{ 
                fontSize: "20px", 
                color: "#ff8c00"
              }} 
            />
            <span>Account Warning</span>
          </div>
        }
        handleCancel={hideModal}
      />
    ),
    body: (
      <div
        className="global-modal-body"
        style={{
          color: getThemeColor("primary-color"),
          fontSize: "15px",
          marginBottom: "0px",
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
        }}
      >
        {warningText}
      </div>
    ),
    footer: <ModalFooter PrimaryButtonList={[]} DefaultButtonList={DefaultButtonList} />,
    width: "520px",
  };

  return (
    <ModalMain
      updatedModal={true}
      modalDetails={modalDetails}
      showModal={showModal}
    />
  );
};

export default AccountWarningModal;